<p-toast 
    [key]="'emergencyAlert'"
    position="top-right" 
    [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
      <div class="flex gap-spacing-xs">
        <div class="icon-container">
          <i class="icon-warning toast-icon size-icon-md"></i>
        </div>
        <div class="p-toast-message mb-0 clickable-toast" (click)="onRideEmergencyClick(message)" (keydown.enter)="onRideEmergencyClick(message)" style="box-shadow: none;">
          <div class="p-toast-summary">{{ message.summary }}</div>
          <div class="p-toast-detail" [innerHTML]="message.detail"></div>
        </div>
      </div>
    </ng-template>
  </p-toast>